import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'

export const GeneralAccountHeadPopup = (props) => {
    return (
        <ModalBasic
            id="accountHeadMaster"
            classParams="!w-[65%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Expense ledger group information</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>Sr no.</label>
                        <TextInput type='number'
                            id='srNo' name='srNo'
                            value={props.expenseLedgerObject.srNo}
                            handleChange={(event) => props.handleChange(event, 'srNo')}
                            disabled
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Account group:</label>
                        <MultiSelectDropdown
                            drpIdentity="Account group"
                            options={props.expenseLedgerObject.accGrpList}
                            value={props.expenseLedgerObject.selectedAccGrp}
                            onChange={(event) =>
                                props.setFilterParameters(event, "selectedAccGrp")
                            }
                            isDisabled={true}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Account head:</label>
                        <MultiSelectDropdown
                            drpIdentity="Account head"
                            options={props.expenseLedgerObject.accHeadList}
                            value={props.expenseLedgerObject.selectedAccHead}
                            onChange={(selected) =>
                                props.setFilterParameters(selected, "selectedAccHead")
                            }
                        />
                    </div>
                </div>
                <div className='item-grp grid grid-cols-2 gap-2.5 mb-2.5'>
                    <div className='input-grp'>
                        <label>Expense ledger name:</label>
                        <TextInput type='text'
                            id='expLedgerName' name='expLedgerName'
                            value={props.expenseLedgerObject.expLedgerName}
                            handleChange={(event) => props.handleChange(event, 'expLedgerName')}
                            className={props.validState?.error?.expLedgerName !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Ledger code:</label>
                        <TextInput type='number'
                            id='ledgerCode' name='ledgerCode'
                            value={props.expenseLedgerObject.ledgerCode}
                            handleChange={(event) => props.handleChange(event, 'ledgerCode')}
                        />
                    </div>
                </div>
                <div className='item-grp grid grid-cols-3 gap-2.5 mb-2.5'>
                    <div className='input-grp'>
                        <label>Opening balance date:</label>
                        <TextInput type='date'
                            id='openingBalanceDate' name='openingBalanceDate'
                            value={props.expenseLedgerObject.openingBalanceDate}
                            handleChange={(event) => props.handleChange(event, 'openingBalanceDate')}
                            className={` ${props.validState?.error?.openingBalanceDate ? "error" : ""}`}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Opening balance:</label>
                        <TextInput type='number'
                            id='openingBalance' name='openingBalance'
                            value={props.expenseLedgerObject.openingBalance}
                            handleChange={(event) => props.handleChange(event, 'openingBalance')}
                            className={` ${props.validState?.error?.openingBalance ? "error" : ""}`}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Balance type:</label>
                        <MultiSelectDropdown
                            drpIdentity="Balance type"
                            options={props.expenseLedgerObject.types}
                            value={props.expenseLedgerObject.types.find(x => x.value === props.expenseLedgerObject.balanceTypeId)}
                            onChange={(event) =>
                                props.handleChange(event, "balanceType")
                            }
                            className={` ${props.validState?.error?.balanceTypeId ? "error" : ""}`}
                        />
                    </div>
                    <div className='input-grp !inline-flex !gap-[10px]'>
                        <label>Is carry Forward?:</label>
                        <input type='CheckBox'
                            className='shadow-none w-[15px] h-[15px]'
                            id='isCarryForward' name='isCarryForward'
                            value={props.expenseLedgerObject.isCarryForward}
                            checked={props.expenseLedgerObject.isCarryForward}
                            onClick={(event) => props.handleChange(event, 'isCarryForward')}
                        />
                    </div>
                </div>

                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()} >Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}